// extracted by mini-css-extract-plugin
export default {"overlay":"InfoModal_overlay__JW0zS","modal":"InfoModal_modal__eG4dB","closeButton":"InfoModal_closeButton__49oj5","infoBox":"InfoModal_infoBox__JvjK3"};